import styled from 'styled-components';
import { PriceVatExcludedStyled } from '../PriceVatExcludedStyled';

export const PriceVatExcludedStyledOV = styled(PriceVatExcludedStyled)`
    color: ${({ theme }) => theme.colors.grey22};
`;
